import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App.js';
import './index.css';
import './styles/themes/default-glass.css';
import './styles/themes/matcha-horizon.css';
import './styles/themes/midnight-eagle.css';
import './styles/themes/midnight-obsidian.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

